import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { IPlanContent } from '../typings';
import { defaultEstimatesDialog, ongoingKeyDetails } from './common/planDefaults';

export const originWeekendShiftContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Weekend Shift']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing plan',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekend-shift.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekend-shift.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekend-shift.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Variable rates on an ongoing plan',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
